import CASTokenStrategy from './casTokenStrategy';
import JWTTokenStrategy from './jwtTokenStrategy';
import ColaboratorTokenStrategy from './colaboratorTokenStrategy';

export default class TokenStrategyFactory {
  static getTokenStrategy(tokenKind) {
    switch (tokenKind) {
      case 'jwt':
        return new JWTTokenStrategy();
      case 'cas':
        return new CASTokenStrategy();
      case 'colaborator':
        return new ColaboratorTokenStrategy();
      default:
        throw new Error('invalid token kind');
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/tokenStrategies/tokenStrategyFactory.js